/** @jsxImportSource @emotion/react */
import { Typography, createStyles, useTheme } from '@quickbit/qb-design-system';
import { ReactNode } from 'react';
import { EmptyIllustration } from '../assets/EmptyIllustration';

interface Props {
  heading: string;
  body: string;
  action?: ReactNode;
}

export const EmptyContent = ({ heading, body, action }: Props) => {
  const styles = useStyles();
  const { palette } = useTheme();

  return (
    <div css={styles.root}>
      <EmptyIllustration css={styles.image} />
      <div css={styles.content}>
        <Typography variant="subtitle" color={palette.grey.x900}>
          {heading}
        </Typography>
        <Typography variant="body" color={palette.grey.x500}>
          {body}
        </Typography>
        {action && <div css={styles.action}> {action}</div>}
      </div>
    </div>
  );
};

const useStyles = createStyles(({ spacing }) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: spacing.l,
  },
  content: {
    maxWidth: 380,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    'p + p': {
      marginTop: spacing.xxs,
      textAlign: 'center',
    },
  },
  image: {
    width: 119,
    height: 88,
    marginBottom: spacing.m,
  },
  action: {
    marginTop: spacing.m,
  },
}));
